import jQuery from 'jquery';
const $ = jQuery;

const initVenueFilter = () => {
  if (typeof $ === 'undefined') {
    console.log('jQuery is not loaded.');
    return false;
  }

  const target = $('.search-container');
  const nonce = $('input[name="nonce"]').val();
  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  const restBase = protocol + '//' + hostname + '/wp-json/venues-rest/v1';
  let requestCount = 0;
  let letter_filtered = [];
  let posts_per_page = -1;
  let clear_search = false;

  $('.choose-button').on('change', function () {
    if ($(this).find('option:selected').val() !== '' ) {
      setActive($(this).find('option:selected'));
      posts_per_page = -1;
      clear_search = false;
      getFilteredData(posts_per_page, firstLetter(),getTerms('venue-capacity'),getTerms('venue-environment'),getTerms('venue-space-type'),getTerms('venue-feature'), clear_search);
    }
  });

  $('.filter-item-letter').on('click', function () {
    var filter_value = $(this).attr('data-id');
    var filter_text = $(this).text();

    $('.filter-item-letter').removeClass('uk-active');
    $(this).addClass('uk-active');
    $('.search-tabs-container button[data-type="letter-filter"]').remove();

    posts_per_page = -1;
    clear_search = false;
    addTab(filter_value, filter_text, 'letter-filter');
    getFilteredData(posts_per_page, firstLetter(),getTerms('venue-capacity'),getTerms('venue-environment'),getTerms('venue-space-type'),getTerms('venue-feature'), clear_search);
  });

  function setActive(e) {
    let filter_value = $(e).attr('data-id');
    let filter_text = $(e).text();
    let filter_type = $(e).attr('data-type');
    let button_text = $(e).attr('id');

    if (e.hasClass('uk-active')) {
      e.removeClass('uk-active');
      e.attr('aria-selected', 'false');
      $('option[data-type="' + filter_type + '"]').show();
      $('.search-tabs-container button[data-id="' + filter_value + '"]').remove();
      $('select#' + filter_type).attr('aria-activedescendant', '');
    } else {
      $('option[data-type="' + filter_type + '"]').hide();
      e.show();
      e.addClass('uk-active');
      e.attr('aria-selected', 'true');
      $('select#' + filter_type).attr('aria-activedescendant', button_text);
      addTab(filter_value, filter_text, filter_type);
    }
  }

  function addTab(filter_value, filter_text, filter_type) {
    $('.search-tabs-container').append(`<button data-id="` + filter_value + `" data-type="` + filter_type + `" class="filter-tab">
      ` + filter_text + `
        <svg class="icon icon-close" aria-hidden="true">
            <use xlink:href="#icon-close"></use>
        </svg> 
      </button>`);

    $('.filter-tab').on('click', function (e) {
      var id = $(this).attr('data-id');
      var type = $(this).attr('data-type');
      removeTab(id, type);
    });
  }

  function firstLetter() {
    const letter = [];
    $('.alphabet-search button.uk-active').each(function () {
        letter.push($(this).attr('data-id'));
    });
    letter_filtered = letter;
    return letter;
  }

  function getTerms(taxonomy_slug) {
    const terms = [];
    $(`.${taxonomy_slug}.uk-active`).each(function () {
      terms.push($(this).attr('data-id'));
    });
    return terms;
  }

  function getFilteredData(posts_per_page, first_letter, capacity, environment, space_type, feature, clear_search) {
    requestCount++;

    var data = {
      first_letter: first_letter,
      capacity: capacity,
      environment: environment,
      space_type: space_type,
      feature: feature,
      posts_per_page: posts_per_page,
    };

    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        data: data,
      }),
    };

    fetch(restBase + '/search', options)
      .then((response) => {
        if (!response.ok) {
          const statusError = 'Error getting Search from API';
          console.log(statusError);
          console.log(response);
        }
        return response.json();
      })
      .then((response) => {
        if (requestCount > 1) {
          requestCount--;
        } else {
          requestCount--;

          $('#load-more-venues').hide();
          
          if (response.posts === '') {
            target.fadeOut('fast');
            $('.venue-page-search__no-results').fadeIn();
          } else {
            $('.venue-page-search__no-results').fadeOut();
            target.fadeOut('fast');
            setTimeout(function () {
              target.empty().append(response.posts).fadeIn('fast');
              $('.venue-box').show();
              $('.current-letter').show();
              
              if (clear_search === true) {
                $('.pagination-container').fadeIn();
                $('.clear-search').removeClass('active-clear');
                $('.filter-headline').remove();
              } else {
                $('.pagination-container').fadeOut();
                $('.clear-search').addClass('active-clear');
              }

            }, 200);
          }
        }
      })
      .catch((response) => {
        console.log(response);
      });
  }

  $('.clear-search').on('click', function (e) {
    e.preventDefault();
    posts_per_page = -1;
    clear_search = true;
    $('.filter-item.uk-active').removeClass('uk-active').attr('aria-selected', 'false');
    $('.filter-item-letter.uk-active').removeClass('uk-active').attr('aria-selected', 'false');
    $('.choose-button option').show();
    $('#load-more-venues').attr('data-filter', 'false');
    $('.search-tabs-container').html('');
    $('.choose-button').attr('aria-activedescendant', '');
    $('.main-option').prop('selected', true);
    $('.current-letter').show();
    getFilteredData(posts_per_page, firstLetter(),getTerms('venue-capacity'),getTerms('venue-environment'),getTerms('venue-space-type'),getTerms('venue-feature'), clear_search);
  });

  function removeTab(filter_value, type) {
    $('.search-tabs-container button[data-id="' + filter_value + '"]').remove();
    $('.filter-item[data-id="' + filter_value + '"]').removeClass('uk-active');
    $('.filter-item[data-id="' + filter_value + '"]').attr('aria-selected', 'false');
    $('.filter-item-letter[data-id="' + filter_value + '"]').removeClass('uk-active');
    $('.filter-item-letter[data-id="' + filter_value + '"]').attr('aria-selected', 'false');
    $('option[data-type="' + type + '"]').show();
    $('select#' + type).attr('aria-activedescendant', '');
    $('.main-option[data-type="' + type + '"]').prop('selected', true);
    $('.current-letter').show();
    posts_per_page = -1;  
    
    if ($('.search-tabs-container button').length === 0) {
      clear_search = true;
      $('#load-more-venues').attr('data-filter', 'false');
    }

    getFilteredData(posts_per_page, firstLetter(),getTerms('venue-capacity'),getTerms('venue-environment'),getTerms('venue-space-type'),getTerms('venue-feature'), clear_search);
  }
};

export default initVenueFilter;